import React from 'react';

import {useMediaQuery} from '../../hooks/useMediaQuery';
import {serviceMotionList} from '../../utils/serviceMotionList';

import FeatureCardBox from '../common/FeatureCardBox';

import {ReactComponent as CursorImg} from '../../assets/chat03/cursor.svg';
import {ReactComponent as DocumentExampleImg} from '../../assets/chat03/document-example.svg';
import {ReactComponent as DocumentImg} from '../../assets/chat03/document.svg';
import {ReactComponent as SourcePopImg} from '../../assets/chat03/source-pop.svg';
import {ReactComponent as SourceImg} from '../../assets/chat03/source.svg';

export default function Chat03() {
    const mobileSmall = useMediaQuery('(max-width: 480px)');
    const mobileMedium = useMediaQuery('(min-width: 481px) and (max-width: 768px)');

    const getSubTitle = () => {
        if (mobileSmall) return <>문서 정보를 답할 경우 출처를 제공하여<br /> 신뢰성을 높여요</>;
        if (mobileMedium) return <>문서 정보를 답할 경우 출처를 제공하여 신뢰<br />성을 높여요</>;

        return '문서 정보를 답할 경우 출처를 제공하여 신뢰성을 높여요'
    };

    const dataMap = [
        { 
            type: 'document',
            title: '출처 제공',
            subTitle: getSubTitle(),
            Image: DocumentExampleImg,
            SecondImage: SourcePopImg,
            ThirdImage: CursorImg,
            FourImage: SourceImg
        }
    ];

    return (
        <FeatureCardBox
            type='document'
            IconImage={DocumentImg}
            keyword='문서 검색'
            title={mobileSmall ? <>문서에서 필요한 정보만<br />쏙쏙! 알려드려요</> : '문서에서 필요한 정보만 쏙쏙! 알려드려요'}
            featureCardList={dataMap}
            titleMotion={serviceMotionList.titleMotion}
            cardMotion={serviceMotionList.cardMotion}
            motionVariant={serviceMotionList.chat03}
        />
    );
}
